/*!
    * @product/scmp-sdk 1.1.1
    * built by undefined
  */
import{h as t}from"./chunk-77EKBZCB.js";var r=()=>{let{acquisition:{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}}=t();return{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}};export{r as a};
//# sourceMappingURL=chunk-FUDVVMMT.js.map
